'use client'
import React from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import styled from 'styled-components'

import InformationTabs from '../../modules/informationTabs'
import TypographyElement from '../../elements/typography'
import CardMedia from '../../compositions/informationImageCard'
import Width from '../../elements/widthContainer'
import { innerHtml } from '../../utils/innerHtml'
import ButtonElement from '../../elements/buttons'

const InformationWrapper = styled.div`
  .introText {
    padding-bottom: 10px;
    max-width: 875px;
  }

  .tabContainer {
    padding-bottom: 20px;
    min-height: 104px;
  }

  .informationCards {
    padding: 20px 0;
  }

  .informationButtons {
    text-align: right;

    @media screen and (max-width: 650px) {
      button {
        border: 1px solid black;
      }
    }
    @media screen and (max-width: 3450px) {
      button {
        svg {
          display: none;
        }
      }
    }
  }

  .cardwrapper {
    display: inline-block;
    vertical-align: top;
    width: 25%;
    padding-left: 20px;

    &.large {
      width: 50%;
      padding-left: 0;
    }

    @media screen and (max-width: 1200px) {
      width: 100%;
      padding-left: 0;

      &.large {
        width: 100%;
        padding-left: 0;
      }
    }
  }

  .contentModule {
    padding-bottom: 60px;
  }

  .infoCardWrapper {
    display: inline-block;
    vertical-align: top;
    padding: 20px;
    width: 25%;
  }

  @media screen and (max-width: 1000px) {
    .infoCardWrapper {
      width: 33%;
    }
  }
  @media screen and (max-width: 800px) {
    .infoCardWrapper {
      width: 50%;
    }
  }
  @media screen and (max-width: 600px) {
    .infoCardWrapper {
      width: 100%;
    }
  }
`

const NewsModuleCards = ({ title, button, children, handleButton }) => {
  if (!children || children.length == 0) {
    return null
  }
  return (
    <div className="contentModule">
      <TypographyElement variant="ctaText">{title}</TypographyElement>

      <div className="informationCards">
        {children?.map((item, index) => {
          if (index > 2) {
            return
          }

          return (
            <div
              key={`information-cards-ch-${index}`}
              className={`cardwrapper ${index === 0 ? 'large' : ''}`}
            >
              <CardMedia {...item} isLarge={index === 0} maxWidth />
            </div>
          )
        })}
      </div>

      <div className="informationButtons">
        <ButtonElement variant="secondary" handleClick={handleButton}>
          <TypographyElement variant="footerText">{button}</TypographyElement>
        </ButtonElement>
      </div>
    </div>
  )
}

const Information = ({ intro, content }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const tab = searchParams.get('tab')

  const tabButtons = React.useMemo(() => {
    let tabButtons = [
      {
        id: 0,
        title: 'Alle informatie',
      },
    ]
    content.forEach((item, i) => {
      tabButtons.push({
        id: i + 1,
        title: item.tab,
        name: item.title,
        slug: item.slug,
      })
    })
    return tabButtons
  }, [content])

  const [active, info] = React.useMemo(() => {
    let activeTab = 0
    let newInfo = content
    if (tab) {
      // If tab in query, find the proper tab and info
      activeTab = tabButtons?.find((item) => item.slug == tab)?.id
      newInfo = content.find((item) => {
        return item.slug == tab
      })
    }
    return [activeTab, newInfo]
  }, [tab, content, tabButtons])

  const handleNewUrl = (tab, scroll = false) => {
    const path = tab ? `/informatie?tab=${tab}` : '/informatie'
    if (window) {
      router.push(path, { scroll })
    }
  }

  const handleTabClick = React.useCallback((val) => {
    const newVal = val.id === active ? 0 : val.id
    handleNewUrl(newVal == 0 ? '' : val.slug, false)
  }, [active, handleNewUrl])

  return (
    <InformationWrapper>
      <Width>
        <div className="introText">
          <TypographyElement variant="title" component="h2">
            {intro.title}
          </TypographyElement>

          <TypographyElement variant="p">
            {innerHtml(intro.text)}
          </TypographyElement>
        </div>

        <div className="tabContainer">
          <InformationTabs
            buttons={tabButtons}
            activeId={active}
            handleClick={handleTabClick}
          />
        </div>

        <div className="mainContent">
          {active == 0 && (
            <div className="sectionWrap">
              {content?.map((card, index) => (
                <NewsModuleCards
                  {...card}
                  key={`${card.title}-${index}`}
                  handleButton={(e) => {
                    e.preventDefault()
                    handleNewUrl(card.slug, true)
                  }}
                />
              ))}
            </div>
          )}

          {active != 0 && (
            <div className="sectionWrap">
              <div className="informationCards">
                {info?.children?.map((item, index) => {
                  return (
                    <div
                      key={`information-cards-ch-${index}`}
                      className="cardwrapper"
                    >
                      <CardMedia {...item} maxWidth />
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </Width>
    </InformationWrapper>
  )
}
export default Information
